import React, { useEffect, useRef, useState } from 'react';
import { Collapse } from 'react-collapse';
import { ReactComponent as Ic_Carret_up } from 'resources/icons/Ic_chevron--up.svg';
import { ReactComponent as Ic_Carret_down } from 'resources/icons/Ic_chevron--down.svg';
import SvgIcon from '../icons/SvgIcon';

import './dropdown.scss';
import IconPromise from 'components/widgets/IconPromise/IconPromise';

export default function Dropdown(props, ref) {
  //en caso de modificar la lista, se debe actualizar el valor de seleccionado
  useEffect(() => {
    setSelected(props.selected);
  }, [props.selected]);

  const [opened, setOpened] = useState(false);
  const [selected, setSelected] = useState(props?.selected) as any;
  const content = useRef(null as any);

  React.useImperativeHandle(ref, () => ({
    setValue: setValue,
    getValue: getValue,
    setOpened: setOpened,
  }));

  const setValue = (value) => {
    if (!value) setSelected(0);
    else setSelected(value);
  };

  const getValue = () => {
    return selected;
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickComponent);
  }, []);

  useEffect(() => () => document.removeEventListener('mousedown', handleClickComponent), []);

  const handleClickComponent = (event: any) => {
    if (content && !content.current?.contains(event.target)) {
      setOpened(false);
    }
  };

  const renderItems = () => {
    let res = [] as any;
    /*     if (props?.items) {
      //Primera opción disabled
      if(props.firstDisabled){
        props.items[0] = props.firstDisabled;
      }
    } */

    for (let item in props?.items) {
      res.push(
        <div
          className={'content-item'}
          key={'dd_' + props?.nameDropdown + item}
          onClick={() => {
            if (props.firstDisabled && parseInt(item) === 0) {
              //Primera opción disabled
            } else {
              setOpened(false);
              if (selected !== parseInt(item)) {
                setSelected(item);
                props?.onChange(props?.items[item]?.value ? props?.items[item]?.value : item);
              }
            }
          }}
        >
          <div className={'item'}>
            {props?.items[item]?.icon && (
              <SvgIcon Icon={props?.items[item]?.icon} ariaLabel={props?.items[item]?.txt} />
            )}
            {props?.items[item]?.iconPromise
            ? (<IconPromise idIcon={props?.items[item]?.iconPromise} style={{ width: 22 }} />)
            :null}
            {props?.items[item]?.txt ? props?.items[item]?.txt : props?.items[item]}
          </div>
          <div className={'divider'} />
        </div>,
      );
    }
    return res;
  };
  return (
    <div
      className={`dropdown ${props.className}`}
      ref={content}
      style={{
        width: props.width ? props.width : '',
        background: props.background ? props.background : '#fff',
        ...props.style,
      }}
    >
      <div
        className={'dropdown-title'}
        style={{
          color: props.colorText ? (opened ? 'black' : props.colorText) : 'black',
          // fontWeight: props.boldText ? 700 : 500
        }}
        onClick={() => setOpened(!opened)}
      >
        {props.icon && <SvgIcon ariaLabel='time' Icon={props.icon} style={{ marginRight: 8 }} />}
        {props.iconPromise && <IconPromise idIcon={props.iconPromise} style={{ marginRight: 8 }} />}
        <div style={{ flexDirection: 'row' }}>
          <span style={{flexGrow:1}}>
            {props?.text
              ? props?.text
              : props?.items
              ? props?.items[selected || 0]?.txt
                ? props?.items[selected || 0]?.txt
                : props?.items[selected || 0]
              : ''}
          </span>
        </div>

        <SvgIcon
          ariaLabel='arrow'
          Icon={opened ? Ic_Carret_up : Ic_Carret_down}
          className={'arrow-icon'}
        />
      </div>
      <div className={'dropdown-content'} style={{...{width: '100%'}, ...props.styleContent}}>
        <Collapse isOpened={opened} >
          {props?.children ? <div className={'children'}>{props?.children}</div> : renderItems()}
        </Collapse>
      </div>
    </div>
  );
}

// @ts-ignore
// eslint-disable-next-line no-func-assign
Dropdown = React.forwardRef(Dropdown);
